import {app} from '../../app';
import {SharedQuestionService} from "../../services/SharedQuestionService";
import IScope = angular.IScope;
import {IQuestionnaireLogicService} from "../../services/LogicService";
import {PageDynamicSharedQuestion} from "../../sharedQuestions/PageDynamicSharedQuestion";
import {IUniqueIdService} from "../../services/UniqueIdService";
import {ISessionService} from "../../services/SessionService";

interface IQuestionComponent {
    question:IQuestion;
    html:string;
    displayed:boolean;
}

export class PageDynamicQuestionComponent implements ng.IComponentController {

    private timeout:ng.ITimeoutService;
    private document:duScroll.IDocumentService;
    private sharedQuestionService:SharedQuestionService;
    private logicService:IQuestionnaireLogicService;
    private sessionService:ISessionService;
    private uniqueIdService:IUniqueIdService;
    private sharedQuestion:PageDynamicSharedQuestion;

    question:IQuestion;
    questions:IQuestion[];
    questionsComponents:IQuestionComponent[] = [];
    uniqueId:string;

    nextQuestionCallback:()=>void;
    showSessionPagination:boolean;
    hasPreviousQuestion:boolean;
    private cancelNextQuestionCallback:()=>void;

    static $inject = ['$timeout', '$document', 'SharedQuestionService', 'QuestionnaireLogicService', 'SessionService', 'UniqueIdService'];

    constructor($timeout:ng.ITimeoutService, $document:duScroll.IDocumentService, sharedQuestionService:SharedQuestionService, LogicService:IQuestionnaireLogicService, SessionService:ISessionService, UniqueIdService:IUniqueIdService) {
        this.timeout               = $timeout;
        this.document              = $document;
        this.sharedQuestionService = sharedQuestionService;
        this.logicService          = LogicService;
        this.sessionService        = SessionService;
        this.uniqueIdService       = UniqueIdService;
    }

    $onInit() {
        this.sharedQuestion          = new PageDynamicSharedQuestion();
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        this.uniqueId = this.uniqueIdService.getUniqueId('page-dynamic-question-component');

        if (this.question.questions != null && this.question.questions.length > 0) {
            this.questions = SharedQuestionService.sortQuestions(this.question.questions);
            for (let index in this.questions) {
                const question = this.questions[index];

                this.questionsComponents.push({
                    question : question,
                    html     : '<' + question.type + '-question question="pageDynamicQuestion.questions[' + index + ']" ' +
                    'question-id="' + question.id + '" ' +
                    'next-question-callback="pageDynamicQuestion.nextQuestionCallback()" ' +
                    'show-session-pagination="pageDynamicQuestion.showSessionPagination"' +
                    'has-previous-question="session.hasPreviousQuestion"' +
                    '></' + question.type + '-question>',
                    displayed: false,
                });
            }
        }

        this.cancelNextQuestionCallback = this.logicService.onNextQuestion(() => {
            if (this.countLeftQuestionComponents() === 0) {
                return true;
            }

            this.displayNextQuestion();

            return false;
        });

        this.timeout(() => {
            for (const questionComponent of this.questionsComponents) {
                const answer = this.sessionService.getAnswer(questionComponent.question.id);

                if (answer && angular.isArray(answer.values)) {
                    this.displayNextQuestion();
                }
            }

            this.displayNextQuestion();
        }, 1000);
    }

    $onDestroy() {
        this.cancelNextQuestionCallback();
    }

    private countLeftQuestionComponents():number {
        let left = 0;

        for (let index = this.questionsComponents.length - 1; index >= 0; index--) {
            const questionComponent = this.questionsComponents[index];

            if (questionComponent.displayed) {
                return left;
            }

            left++;
        }

        return left;
    }

    private nextQuestionComponent(previousQuestion?:IQuestionComponent):IQuestionComponent {
        let next = null;

        for (let index = this.questionsComponents.length - 1; index >= 0; index--) {
            const questionComponent = this.questionsComponents[index];

            if ((previousQuestion && previousQuestion.question.id === questionComponent.question.id) || questionComponent.displayed) {
                return next;
            }

            next = questionComponent;
        }

        return this.questionsComponents[0];
    }

    private displayNextQuestion(nextQuestion?:IQuestionComponent) {
        nextQuestion = nextQuestion ? nextQuestion : this.nextQuestionComponent();

        if (!nextQuestion) {
            return;
        }

        nextQuestion.displayed = true;

        if (!this.questionSatisfied(nextQuestion.question)) {
            this.displayNextQuestion(this.nextQuestionComponent(nextQuestion));
            return;
        }

        this.timeout(() => {
            let element = angular.element('#' + this.uniqueId + ' .sub-dynamic-question').last();
            this.document.duScrollToElementAnimated(element);
        });
    }

    questionSatisfied(question:IQuestion):boolean {
        const displayConditions = question.meta.display_if;

        if (displayConditions && displayConditions.length > 0) {
            for (const condition of displayConditions) {
                for (const conditionSharedQuestion of this.sharedQuestionService.questions) {
                    if (conditionSharedQuestion.question.id !== condition.question) {
                        continue;
                    }

                    const sharedQuestion    = new this.sharedQuestionService.sharedQuestions[conditionSharedQuestion.question.type]();
                    sharedQuestion.question = question;

                    let _return = false;

                    conditionSharedQuestion.preventValidation(() => {
                        if (conditionSharedQuestion.isValid()) {
                            const value  = conditionSharedQuestion.getValue(),
                                  values = angular.isArray(value) ? value : [value];

                            if (sharedQuestion.satisfiesValue(values, condition.value)) {
                                _return = true;
                            }
                        }
                    });

                    if (_return) {
                        return true;
                    }
                }
            }

            let count = 0;
            for (const sharedQuestion of this.sharedQuestionService.questions) {
                if (sharedQuestion.question.id === question.id) {
                    this.sharedQuestionService.questions.splice(count, 1);
                }

                count++;
            }

            return false;
        }

        return true;
    }

}

app.component('pageDynamicQuestion', {
    templateUrl : 'templates/components/questionTypes/pageDynamicQuestion.html',
    controller  : PageDynamicQuestionComponent,
    controllerAs: 'pageDynamicQuestion',
    bindings    : {
        question             : '<',
        nextQuestionCallback : '&',
        showSessionPagination: '=',
        hasPreviousQuestion     : '='
    }
});